/**
 * App availability configuration.
 * Toggle these flags when apps are launched on respective stores.
 */
const appConfig = {
  /** Full web app URL (navbar + hero link) */
  webAppUrl: 'https://app.timeline.net.in',
  ios: {
    launched: true,
    storeUrl: 'https://apps.apple.com/in/app/timeline-social-app/id6765680749',
    // Opens the App Store app directly - needed for Instagram / in-app browsers on iOS
    storeAppUrl: 'itms-apps://apps.apple.com/app/id6765680749',
    qrCodeUrl: '/ios_qr.png',
  },
  android: {
    launched: true,
    storeUrl: 'https://play.google.com/store/apps/details?id=com.gntfamily.timeline.net.in',
    qrCodeUrl: '/android_qr.png',
  },
  deepLinkScheme: 'timeline://',
  contactEmail: 'support@timeline.net.in',
  supportEmail: 'support@timeline.net.in',
};

export default appConfig;
